import { Component } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
    selector: 'app-product-cab',
    templateUrl: './product-cab.component.html',
    styleUrls: ['./product-cab.component.scss']
})

export class ProductCabComponent {
    public image_baseUrl = environment?.imageUrl;
    public clientAbbr = environment?.clientAbbr;
}